import React from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { CommonSection } from '@flightstats/component-lib';
import MobileAppCallout from '../../../../../../shared/components/MobileAppCallout/MobileAppCallout';
import FSFlatButton from '../../../../../../src/components/lib/FSFlatButton';
import FlightTicketComponent from './children/FlightTicket/FlightTicketComponent';
import OtherStopsComponent from './children/OtherStopsComponent';
import FlightCodesharesComponent from './children/FlightCodesharesComponent';
import UpdateTimer from './children/UpdateTimer/UpdateTimer';
import componentBase from '../../../../../../src/lib/component-base';
import { Colors } from '../../../../../../src/constants/style-constants';
import Ad from '../../../../../../shared/components/Ad/Ad';
import { FlightTracker as flightTrackerAds } from '../../../../../FlightTracker/components/ads';
import { loadByCarrierFlightNumberAndDate } from '../../../../redux/actions';

@componentBase('FlightInformation')
export default class FlightInformation extends React.Component {
  static propTypes = {
    arrivalAirport: PropTypes.object,
    codeshares: PropTypes.array,
    departureAirport: PropTypes.object,
    dispatch: PropTypes.func,
    flightNote: PropTypes.object,
    status: PropTypes.object,
    ticketHeader: PropTypes.object,
    segments: PropTypes.array,
    isLanded: PropTypes.bool,
    flightState: PropTypes.string,
    openFlightAlertManager: PropTypes.func,
    subscriptionActive: PropTypes.bool,
    isMobile: PropTypes.bool,
    flightId: PropTypes.number,
    params: PropTypes.object,
  };

  static defaultProps = {
    additionalFlightInfo: { equipment: null, flightDuration: null },
    arrivalAirport: null,
    codeshares: null,
    departureAirport: null,
    operatedBy: null,
    flightNote: null,
    positional: {},
    status: null,
    ticketHeader: null,
    segments: null,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      divStyle: {
        margin: '15px 20px',
      },
      infoTitleStyle: {
        margin: 0,
        display: 'inline-block',
        fontWeight: 700,
      },
      lastUpdatedTextStyle: {
        fontSize: '11pt',
        margin: 0,
        opacity: '.9',
      },
      halfButtonStyle: {
        minWidth: '45%',
        width: '45%',
        marginTop: '10px',
        marginBottom: '10px',
        display: 'inline-block',
      },
      buttonStyle: FSFlatButton.style({
        minWidth: '100%',
        margin: '6px auto',
        minHeight: '40px',
        lineHeight: '12pt',
        fontSize: '12pt',
      }),
      buttonLabelStyle: {
        width: '90%',
        textAlign: 'center',
        textTransform: 'capitalize',
        paddingLeft: '0',
        paddingRight: '0',
        wordWrap: 'normal',
      },
      buttonsDiv: {
        padding: '0 10px',
      },
      maxHeight: 700,
      autoWidth: true,
    };
  }

  handleDepartureConditionsClick = () => {
    this.context.reportButtonPress('ViewDepartureConditions');
    const url = [
      '/airport-conditions/',
      this.props.ticketHeader.departureAirport.fs.toUpperCase(), '/',
    ];
    this.props.dispatch(push(url.join('')));
  };

  handleDelaysClick = () => {
    this.context.reportButtonPress('CalloutAirportDelays');
    this.props.dispatch(push('/airport-delays'));
  };

  handleRefreshDataClick = () => {
    this.context.reportButtonPress('Refresh');
    location.reload();
  };

  handleFlightAlertClick = source => (
    () => {
      const label = `FlightAlert ${source || ''}`.trim();
      this.context.reportButtonPress(label);
      return this.flightAlertUser() ?
        this.openFlightAlertManager(source) :
        this.goToFlightAlertsMarketingPage();
    }
  );

  handleArrivalConditionsClick = () => {
    this.context.reportButtonPress('ViewArrivalConditions');
    const url = [
      '/airport-conditions/',
      this.props.ticketHeader.arrivalAirport.fs.toUpperCase(), '/',
    ];
    this.props.dispatch(push(url.join('')));
  };

  handleExtendedDetailsClick = (source) => {
    const routeParams = this.props.params;

    if (source === 'callout') {
      this.context.reportButtonPress('CalloutViewFlightDetails');
    } else {
      this.context.reportButtonPress('ViewFlightDetails');
    }

    const url = [
      '/flight-details/',
      routeParams.carrier, '/',
      routeParams.flightNumber, '/',
      routeParams.year, '/',
      routeParams.month, '/',
      routeParams.day, '/',
      this.props.flightId,
    ];
    this.props.dispatch(push(url.join('')));
  };

  handleOTPClick = () => {
    this.context.reportButtonPress('OnTimePerformance');
    const { dispatch, params, ticketHeader } = this.props;
    const { fs } = ticketHeader && ticketHeader.departureAirport;
    const url = [
      '/flight-ontime-performance-rating/',
      `${params.carrier}/`,
      `${params.flightNumber}/`,
      fs,
    ].join('');

    dispatch(push(url));
  }

  openFlightAlertManager = (source) => {
    this.props.openFlightAlertManager(source);
  }

  goToFlightAlertsMarketingPage = () => {
    this.props.dispatch(push('/flight-alerts/home'));
  }

  goToSubscription = () => {
    this.props.dispatch(push('/subscription'));
  }

  refreshData = () => {
    this.props.dispatch(loadByCarrierFlightNumberAndDate(this.props.params));
  }

  flightAlertUser = () => {
    const { currentUser } = this.context;
    if (currentUser) {
      const {
        subscriptionActive,
        subscriptionLevel,
      } = currentUser;
      const validUser = subscriptionActive && (subscriptionLevel || 0) > 0;
      return validUser;
    }
    return false;
  }

  flightAlertCompatible = () => {
    if (this.props && this.props.flightNote) {
      const {
        landed,
        canceled,
        final,
      } = this.props.flightNote;
      const {
        isLanded,
        flightState,
      } = this.props;

      return (!landed &&
              !isLanded &&
              !canceled &&
              !final &&
              flightState !== 'currentDatePostFlight');
    }
    return false;
  }

  buttonHelper = (label, id, onClick, backgroundColor, hoverColor) => (
    <FSFlatButton
      id={id}
      label={label}
      backgroundColor={backgroundColor || 'rgb(255, 168, 39)'}
      hoverColor={hoverColor || '#81A2CA'}
      onClick={onClick}
      className='flight-ticket-button'
      style={this.muiDefaultProps.buttonStyle}
      labelStyle={this.muiDefaultProps.buttonLabelStyle}
    />
  );

  renderFlightAlertButton = (source) => {
    if (this.flightAlertCompatible()) {
      return this.buttonHelper(
        'SET UP FLIGHT ALERTS',
        'trackerFlightAlertButton',
        this.handleFlightAlertClick(source),
      );
    }
    return null;
  }

  render() {
    const currentDepartureLabel = `CURRENT ${this.props.ticketHeader.departureAirport.fs} CONDITIONS`;
    const currentArrivalLabel = `CURRENT ${this.props.ticketHeader.arrivalAirport.fs} CONDITIONS`;
    const extendedDetailsLabel = 'SEE FLIGHT DETAILS';
    const refreshDataLabel = 'REFRESH DATA';

    // Auto-refresh is disabled here (interval=0) because flick is polling.
    const updateTimer = <UpdateTimer callbackInterval={0} callback={this.refreshData} />;

    const {
      isMobile,
      subscriptionActive,
      params,
    } = this.props;

    const {
      mediaBreakpoint = {},
      reportButtonPress,
    } = this.context;

    const mobileAdBlock = isMobile && !subscriptionActive ?
      (
        <div className='col-xs-12'>
          <div style={{ margin: '10px auto', width: '300px', height: '250px' }}>
            <Ad
              key={flightTrackerAds.top.id}
              subscriptionActive={subscriptionActive}
              {...flightTrackerAds.top}
            />
          </div>
        </div>
      ) : null;
    return (
      <div>
        <div style={this.muiDefaultProps.divStyle}>
          <h4 style={this.muiDefaultProps.infoTitleStyle}>
            Flight Information
          </h4>
          <p style={this.muiDefaultProps.lastUpdatedTextStyle}>
            {this.props.status.lastUpdatedText}. {updateTimer}
          </p>
        </div>
        <div className='flight-ticket-container'>
          <div className='col-xs-12 col-sm-10 col-md-10 col-lg-10' style={{ marginBottom: '17px' }}>
            <FlightTicketComponent {...this.props} />
            <OtherStopsComponent {...this.props} params={params} segments={this.props.segments} />
          </div>
          <div className='col-xs-12 col-sm-2 col-md-2 col-lg-2'>
            <div className='flight-action-buttons' style={this.muiDefaultProps.buttonsDiv}>
              {this.buttonHelper(extendedDetailsLabel, 'extendedDetailsButton', this.handleExtendedDetailsClick)}
              {this.renderFlightAlertButton()}
              {this.buttonHelper('SEE ON-TIME PERFORMANCE RATING', 'onTimePerformanceButton', this.handleOTPClick)}
              {this.buttonHelper(currentDepartureLabel, 'departureConditionsButton', this.handleDepartureConditionsClick)}
              {this.buttonHelper(currentArrivalLabel, 'arrivalConditionsButton', this.handleArrivalConditionsClick)}
              <div style={{ marginTop: '17px' }}>
                {this.buttonHelper(refreshDataLabel, 'refreshDataButton', this.handleRefreshDataClick, Colors.blue6, Colors.blue8)}
              </div>
            </div>
          </div>
          {mobileAdBlock}
        </div>
        <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12' style={{ paddingRight: '0', borderTop: '5px solid #FAA718', marginTop: '18px' }}>
          <FlightCodesharesComponent
            codeshares={this.props.codeshares}
          />
        </div>
        <div className='col-xs-12 callout'>
          <CommonSection title='Mobile Applications for the Active Traveler'>
            <MobileAppCallout
              mediaBreakpoint={mediaBreakpoint}
              reportButtonPress={reportButtonPress}
            />
          </CommonSection>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightInformation/FlightInformation.js